import React, { useState, useRef, useEffect } from 'react';
import floatingbuttonicon from '../Assets/floatingbuttonicon.png';
import './floatingbutton.css';

function FloatingButton({ togglemenu, setTogglemenu }) {
    const [position, setPosition] = useState(null);
    const dragging = useRef(false);
    const offset = useRef({ x: 0, y: 0 });
    const buttonRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        if (isDragging) {
            document.body.classList.add('modal_removeoverflow');
        } else {
            document.body.classList.remove('modal_removeoverflow');
        }
        return () => {
            document.body.classList.remove('modal_removeoverflow');
        };
    }, [isDragging]);

    const startDrag = (x, y) => {
        const rect = buttonRef.current.getBoundingClientRect();
        offset.current = {
            x: x - rect.left,
            y: y - rect.top,
        };
        dragging.current = true;
        setIsDragging(true);
    };

    const updatePosition = (x, y) => {
        if (!dragging.current) return;
        setPosition({
            top: y - offset.current.y,
            left: x - offset.current.x,
        });
    };

    const stopDrag = () => {
        dragging.current = false;
        setIsDragging(false);
    };

    const handleMouseDown = (e) => {
        startDrag(e.clientX, e.clientY);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        updatePosition(e.clientX, e.clientY);
    };

    const handleMouseUp = () => {
        stopDrag();
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        startDrag(touch.clientX, touch.clientY);
        document.addEventListener('touchmove', handleTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
    };

    const handleTouchMove = (e) => {
        const touch = e.touches[0];
        updatePosition(touch.clientX, touch.clientY);
    };

    const handleTouchEnd = () => {
        stopDrag();
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
    };

    const handleClick = () => {
        if (!dragging.current) {
            setTogglemenu(!togglemenu);
        }
    };

    const dynamicStyle = position
        ? {
            position: 'fixed',
            top: position.top,
            left: position.left,
            cursor: 'grab',
        }
        : {};

    return (
        <div
            ref={buttonRef}
            className="floatingbutton"
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
            onClick={handleClick}
            style={dynamicStyle}
        >
            <img
                className="floatingbuttonicon"
                src={floatingbuttonicon}
                alt="Floating Button"
            />
        </div>
    );
}

export default FloatingButton;